import { Card, Col, Row, message } from "antd";
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import StatisticWidget from "components/shared-components/StatisticWidget";
import { useDispatch } from "react-redux";
import { fetchAllCategory } from "redux/features/category";
import { fetchAllContent } from "redux/features/content";
import { fetchAllSubcategory } from "redux/features/subcategory";
import { fetchAllDashboard } from "redux/features/dashboard";
import moment from "moment";
import "moment/locale/id";
import Sidang from "../sidang";

export const DefaultDashboard = () => {
  const dispatch = useDispatch();
  const [categoryCount, setCategoryCount] = useState(0);
  const [contentCount, setContentCount] = useState(0);
  const [subcategoryCount, setSubcategoryCount] = useState(0);

  const [summary, setSummary] = useState({
    activitiesThisWeek: 0,
    numberOfMembers: 0,
    numberOfFraction: 0,
    numberOfAttendance: 0,
  });

  const getAllCategory = async () => {
    try {
      const response = await dispatch(fetchAllCategory()).unwrap();
      setCategoryCount(response.meta.page.total_data);
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const getAllSubcategory = async () => {
    try {
      const response = await dispatch(fetchAllSubcategory()).unwrap();
      setSubcategoryCount(response.meta.totalData);
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const getAllContent = async (params) => {
    try {
      const response = await dispatch(fetchAllContent(params)).unwrap();
      setContentCount(response.meta.page.total_data);
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const getDashboardSummary = async () => {
    try {
      // panggil redux async thunk
      const res = await dispatch(fetchAllDashboard()).unwrap();

      // kalau API belum ready, fallback ke dummy
      const data = res?.data || {
        activitiesThisWeek: 6,
        numberOfMembers: 45,
        numberOfFraction: 9,
        numberOfAttendance: 35,
      };

      setSummary(data);
    } catch (error) {
      // fallback juga kalau error fetch
      setSummary({
        activitiesThisWeek: 6,
        numberOfMembers: 45,
        numberOfFraction: 9,
        numberOfAttendance: 35,
      });

      message.error(error?.message || "Failed to fetch dashboard data");
    }
  };

  useEffect(() => {
    getDashboardSummary();
  }, []);

  useEffect(() => {
    const filters = {
      page: 1,
      limit: 10,
      sort: "created_at",
    };

    getAllCategory();
    getAllContent(filters);
    getAllSubcategory();
  }, []);

  return (
    <>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <h2>Dashboard</h2>
          <p>
            Jika menemukan bug ataupun error pada aplikasi ini bisa langsung
          </p>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Card>
            <h2>
              Tanggal Hari Ini:{" "}
              {moment()
                .locale("id")
                .utcOffset(7)
                .format("dddd, D MMMM YYYY HH:mm [WIB]")}
            </h2>
          </Card>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Row gutter={24}>
            <Col xs={24} sm={24} md={24} lg={12} xl={12} key={1}>
              <StatisticWidget
                style={{ textAlign: "center" }}
                title={`Kegiatan Minggu Ini`}
                value={summary.activitiesThisWeek}
                // value={contentCount}
              />
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12} key={2}>
              <StatisticWidget
                style={{ textAlign: "center" }}
                title={`Konfirmasi Kehadiran`}
                value={summary.numberOfAttendance}
                // value={subcategoryCount}
              />
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12} key={3}>
              <StatisticWidget
                style={{ textAlign: "center" }}
                title={`Jumlah Anggota Dewan`}
                value={summary.numberOfMembers}
                // value={categoryCount}mm
              />
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12} key={4}>
              <StatisticWidget
                style={{ textAlign: "center" }}
                title={`Jumlah Fraksi`}
                value={summary.numberOfFraction}
                // value={subcategoryCount}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24} key={2}>
          <Sidang></Sidang>
        </Col>
      </Row>
    </>
  );
};

export default withRouter(DefaultDashboard);
